import { Box, Breakpoint, Button, Dialog, Typography } from '@mui/material';

interface IProps {
  unmount: () => void;
  refetch: () => void;
  width?: Breakpoint;
}

export const NoDataDialog = ({ unmount, refetch, width }: IProps) => (
  <Dialog
    open
    onClose={unmount}
    maxWidth={width ? width : 'lg'}
    fullWidth
    scroll='paper'
  >
    <Box
      sx={{
        minHeight: '50vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      <Typography variant='h6'>
        Fehler beim Laden der Daten. Bitte versuchen Sie es erneut.
      </Typography>
      <Button variant='contained' onClick={() => refetch()}>
        Erneut versuchen
      </Button>
    </Box>
  </Dialog>
);
